'use strict';
var SearchButtonIcon;
(function (SearchButtonIcon) {
    SearchButtonIcon["Magnifier"] = "magnifier";
})(SearchButtonIcon || (SearchButtonIcon = {}));
export default SearchButtonIcon;
